(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-scent-list"]) return;
  try {
    
  class ScentList extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.controlButtons = this.querySelectorAll('.control-button');
      this.contentElements = this.querySelectorAll('[data-content]');

      this.data = this.querySelector('[data-scent-list-json]');

      this.controlButtons.forEach((button) => {
        button.addEventListener('click', () => {
          this.controlButtons.forEach((controlButton) => {
            controlButton.classList.remove('active');
          });

          this.contentElements.forEach((content) => {
            if (content.dataset.content === button.dataset.contentTarget) {
              button.classList.add('active');
              content.style.display = '';
            } else {
              content.style.display = 'none';
            }
          });
        });
      });
    }

    disconnectedCallback() {}
  }

  customElements.define('scent-list', ScentList);

  } catch(e) { console.error(e); }
})();
})();
